export default class CustomError extends Error {
    static createCustomErrorMessage(customErrorMessage) {
        return {
            answer: customErrorMessage
        }
    }
}
